import * as React from "react";
import { Payment } from "@graffer-inc/cloud-gov-core";
import { PaymentItemTable } from "./payment-item-table";
import { PaymentSummaryV2 } from "../common/payment-summary-v2";

export type PaymentDetailProps = {
  payment: Payment;
};

export const PaymentDetail: React.FC<PaymentDetailProps> = ({ payment }) => {
  return (
    <>
      <PaymentItemTable invoice={payment.invoice} />
      <PaymentSummaryV2 payment={payment} />
    </>
  );
};
